import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import useWindowScrollPosition from '../../hooks/useWindowScrollPosition';
import { toggleMobileNav } from '../../actions/navigationActions';
import { navigationItem } from '../../models';
import * as StyledHeader from './header.styles';
import { ReactComponent as IconLock } from '../../figures/lock.svg';
import { Button } from '../base';
import { MINAR_SIDUR_URL } from '../../constants/urls';

const END_LEVEL = 2;

const traverseSubNav = items => items.map(item => !item.Hidden && (
	<StyledHeader.SubNavItem key={item.Id}>
		<Link to={item.Url}>
			{item.Name}
		</Link>
	</StyledHeader.SubNavItem>
));

const traverse = (items, level) => items.map(item => !item.Hidden && (
	<StyledHeader.NavItem key={item.Id}>
		<Link to={item.Url}>
			<StyledHeader.AnchorAnimation>
				{item.Name}
			</StyledHeader.AnchorAnimation>
		</Link>
		{
			item.Children && item.Children.filter(x => !x.Hidden).length > 0 && level < END_LEVEL && (
				<StyledHeader.SubNav>
					{traverseSubNav(item.Children, level + 1)}
				</StyledHeader.SubNav>
			)
		}
	</StyledHeader.NavItem>
));

const Header = ({
	loading,
	navigation,
	mobileNavOpen,
	dispatch,
	error
}) => {
	const onBurgerClick = () => {
		dispatch(toggleMobileNav(!mobileNavOpen));
	};

	const { y } = useWindowScrollPosition();

	return (
		<StyledHeader.Header>
			<StyledHeader.HeaderBackground scrolled={y > 100} />
			<StyledHeader.HeaderInner>
				<StyledHeader.NavItem>
					<StyledHeader.LogoWrapper>
						<Link to="/">
							<StyledHeader.Logo />
							<StyledHeader.MobileLogo />
						</Link>
					</StyledHeader.LogoWrapper>
				</StyledHeader.NavItem>
				<StyledHeader.ContentWrapper>
					<StyledHeader.Navigation>
						{
							!loading && !error && traverse(navigation[0].Children, 1)
						}
					</StyledHeader.Navigation>
					{/* Not showing this atm */}
					<StyledHeader.Tools>
						<Button as="a" href={MINAR_SIDUR_URL} target="_blank" headerNight>
							<IconLock />
							<span>Mínar síður</span>
						</Button>
						<StyledHeader.MobileHamburger
							onClick={onBurgerClick}
							open={mobileNavOpen}
						/>
					</StyledHeader.Tools>
				</StyledHeader.ContentWrapper>
			</StyledHeader.HeaderInner>
		</StyledHeader.Header>
	);
};

Header.propTypes = {
	loading: PropTypes.bool,
	navigation: PropTypes.arrayOf(navigationItem),
	mobileNavOpen: PropTypes.bool,
	error: PropTypes.bool
};

Header.defaultProps = {
	loading: false,
	navigation: [],
	mobileNavOpen: false,
	error: false
};

const mapStateToProps = ({ navigationReducer }) => {
	return {
		loading: navigationReducer.loading,
		navigation: navigationReducer.navigation,
		mobileNavOpen: navigationReducer.mobileNavOpen,
		error: navigationReducer.error
	};
};

export default connect(mapStateToProps)(Header);
